export default "__VITE_PUBLIC_ASSET__604013ab__"